import { DisplayGame } from '../data/types';
import { leagueGroupsGamesByKickoff } from '../data/leagueConfig';
import { lockedChipText } from '../data/propsAvailability';

export interface GameGroup {
  key: string;
  /** Group heading (weekday). Null when the league doesn't group, so callers render a flat strip. */
  label: string | null;
  games: DisplayGame[];
}

/**
 * Group games by local calendar day for leagues whose slate spans several days (NFL: Thu–Mon).
 * Games arrive sorted by kickoff, so insertion order is chronological.
 */
export function groupGamesByKickoff(games: DisplayGame[], league: string): GameGroup[] {
  if (!leagueGroupsGamesByKickoff(league)) {
    return [{ key: 'all', label: null, games }];
  }

  const groups = new Map<string, GameGroup>();
  for (const game of games) {
    const date = new Date(game.startTime);
    const valid = !isNaN(date.getTime());
    const key = valid ? `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}` : 'tbd';
    const label = valid ? date.toLocaleDateString('en-US', { weekday: 'long' }) : 'TBD';
    const group = groups.get(key);
    if (group) {
      group.games.push(game);
    } else {
      groups.set(key, { key, label, games: [game] });
    }
  }
  return Array.from(groups.values());
}

/**
 * Chip time text. Open games show kickoff (the group heading already carries the weekday, so it's dropped
 * when grouped). Games whose props haven't opened show the open time instead — with its weekday, since it
 * falls on a different day than the group heading.
 */
export function kickoffChipTime(game: DisplayGame, grouped: boolean, openTime?: Date | null): string {
  if (openTime) return lockedChipText(openTime);
  return grouped ? game.time.replace(/^[A-Za-z]{3}\s+/, '') : game.time;
}
